import React from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useTheme } from '../../contexts/ThemeProvider'
import { SOLVENCY_DASHBOARD_URL } from '../../utils/Enviroment'
import closeIconLight from '../../assets/close-icon-modal-liquidty.svg'
import closeIconDark from '../../assets/close-icon-solvency-dark.svg'
import './solvencylimitmodal.scss'

const SolvencyLimitModal = ({ show, onHide }) => {
    const { theme } = useTheme()
    const { t } = useTranslation()

    const handleViewDashboard = () => {
        window.open(SOLVENCY_DASHBOARD_URL, "_blank", "noopener,noreferrer")
    }

    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            className="solvency-limit-modal"
            backdropClassName="solvency-limit-backdrop"
        >
            <div className="solvency-modal-header">
                <h5>{t("Notice")}</h5>
                <button type="button" className="close-btn" onClick={onHide} aria-label={t("Close")}>
                    <img src={theme === "dark" ? closeIconDark : closeIconLight} alt="" width={22} height={22} />
                </button>
            </div>
            <div className="solvency-modal-body">
                <div className="pause-icon">
                    <span></span>
                    <span></span>
                </div>
                <h6>{t("Trade can't be placed")}</h6>
                <p className="description">
                    {t("This trade can't go through because USDR is at its solvency limit. Your existing positions are not affected.")}
                </p>
                <div className="note">
                    <p>{t("You can still claim winnings and cancel open orders. Check the solvency dashboard for live status.")}</p>
                </div>
            </div>
            <div className="solvency-modal-actions">
                <button type="button" className="secondary-btn" onClick={handleViewDashboard}>
                    {t("View solvency dashboard")}
                </button>
                <button type="button" className="primary-btn" onClick={onHide}>
                    {t("Got it")}
                </button>
            </div>
        </Modal>
    )
}

export default SolvencyLimitModal
